import { render, staticRenderFns } from "./edit-multi-consent.vue?vue&type=template&id=cfe2f8e4&scoped=true&"
import script from "./edit-multi-consent.vue?vue&type=script&lang=js&"
export * from "./edit-multi-consent.vue?vue&type=script&lang=js&"
import style0 from "./edit-multi-consent.vue?vue&type=style&index=0&id=cfe2f8e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe2f8e4",
  null
  
)

component.options.__file = "edit-multi-consent.vue"
export default component.exports